// breadcrumbMappings.js

import { Assignment } from "@mui/icons-material";

export const breadcrumbMappings = {
  MaxBreadCrumbLength: 3,

  Action: 'Action',
  AddressPurpose: 'Address Purpose',
  AllPhysicalInventoryList: 'All Physical Inventory',
  AssetList: 'Asset List',
  AssetTrackerAdminList: 'Asset Tracker',
  AssetTrackerList: 'My Assets',
  admin: 'Admin',
  AllItemReqTag: 'Approved Item Requisitions',
  account: 'Account',
  BankAccountType: 'Bank Account Type',
  BankName: 'Bank Name',
  BloodGroup: 'Blood Group',
  BusinessRole: 'Business Role',
  BusinessUnit: 'Business Unit',
  listAndCalendarView: 'Interview Calendar',
  calenderUpdate: 'Scheduled Interview',
  CanReqManagerList: 'Candidate Requisitions',
  CanReqTagList: 'Candidate Requisitions',
  CanReqApproval: 'Candidate Requisition Approvals',
  CandidateStatusViewList: 'Candidate Status List',
  CandidateStatusViewMgrList: 'Candidate Status List',
  Certificates: 'Certificate',
  ContractType: 'Contract Type',
  calendarform: 'Schedule Interview',
  client: 'Client',
  ClientMst: 'New Client',
  CandidateRequirement: 'Candidate Requisition',
  CertificateType: 'Certificate Type',
  CancelCanReq: 'Candidate Requisition Cancellations',
  dashboard: 'Dashboard',
  DeliveryUnit: 'Delivery Unit',
  Department: 'Department',
  Designation: 'Designation',
  Domain: 'Domain',
  DetailsJd: 'Job Description Details',
  detailRoleperm: 'View Role Permission',
  DetailVendor: 'Vendor Details',
  DetailClient: 'Client Details',
  DetailsReq: 'Requisition Details',
  DeclineReason: 'Offer Decline Reason',
  EditCandidate: 'Edit Candidate',
  CandUnderReviewEdit: 'Under Review Candidates',
  EditClient: 'Edit Client',
  EditEmployee: 'Edit Employee',
  EmpUnderReviewEdit: 'Under Review Employees',
  EditItem: 'Edit Item',
  EditJd: 'Edit Job Description',
  EditReq: 'Edit Requisition',
  EmpGrade: 'Employee Grade',
  EmploymentType: 'Employment Type',
  EmpDoc: 'Employee Onboarding Documents',
  editRoleperm: 'Edit Role Permission',
  EditVendor: 'Edit Vendor',
  employee: 'Employee',
  edit: 'Edit Project',
  Gender: 'Gender',
  HsnSac: 'HSN/SAC',
  Institute: 'Institute',
  InspectionList: 'Material Inspection',
  InvComparisonList: 'Inventory Comparison',
  InspectionParameter: 'Inspection Parameters',
  // InvComparisonList: 'Inventory Comparison List',
  InspectionParameterMasterList: 'Inspection Parameters List',
  InterviewDashboard: 'Interview Pipeline',
  RecruiterAssignment: 'Recruiter Assignment',
  InterviewFeedbackView: 'Interview Feedback View',
  InterviewLevel: 'Interview Level',
  InterviewResult: 'Interview Feedback',
  InterviewResultEdit: 'Interview Feedback Edit',
  InterviewStatus: 'Interview Status',
  ItemRequisition: 'Material Requisition',
  ItemCondition: 'Item Condition',
  ItemCategoryMst: 'Item Category',
  ItemType: 'Item Type',
  interview: 'Interview',
  inventory: 'Inventory',
  InvTransaction: 'Inventory Transaction',
  InvTransactionList: 'Inventory Transaction List',
  InvOnHandList: 'On Hand Quantity',
  InterviewCancelReason: 'Interview Cancel Reason',
  invcomparison: 'Inventory Comparison',
  interviewfetch: 'Interview',
  jd: 'Job Description (JD)',
  Language: 'Language',
  ListCandidate: 'Candidate List',
  ListOfUnderReviewedCand: 'Under Review Candidates',
  ListEmployee: 'Employee List',
  AddOffclEmail: 'Official Email Addon',
  ListInterview: 'My Interviews',
  ListClient: 'Client List',
  ListVendor: 'Vendor List',
  list: 'Item Master',
  MaritalStatus: 'Marital Status',
  MeetingPlatform: 'Meeting Platform',
  Modules: 'Modules',
  master: 'Master',
  ManagerApproval: 'Manager Approval',
  MaterialReqApproval: 'Material Requisition Approvals',
  NameTitle: 'Salutation',
  NegativeFeedback: 'Negative Feedback',
  NewCandidate: ' New Candidate',
  NewEmployee: 'New Employee',
  ListOfUnderReviewedEmp: 'Under Review Employees',
  NewJd: 'New Job Description',
  NewItem: 'New Item',
  NewRequirement: 'New Candidate Requisition',
  new: 'New Role Permission',
  OrganizationType: 'Organization Type',
  OfferLetter: 'Offer Letter',
  offeredit: 'Edit Offer Letter',
  offerfetch: 'Offer Letter',
  OfferLetterPreview: 'Offer Letter Preview',
  OfferedCandidates: 'Offered Candidates',
  PastJd: 'Job Description List',
  PhysicalInventoryList: 'Physical Inventory List',
  PositionLevel: 'Position Level',
  Practice: 'Practice',
  PreferenceType: 'Preference Type',
  ProjectStatus: 'Project Status',
  ProjectCategory: 'Project Category',
  PTList: 'Project Type',
  product: 'Item',
  PurReqApproval: 'Purchase Requisition Approvals',
  MstDataApproval: 'Master Data Approval',
  projectallocationform: 'Project Allocation',
  projectform: 'New Project',
  projectlist: 'Project List',
  purchasereq: 'Approved Purchase Requisitions',
  project: 'Project List',
  Qualification: 'Qualification',
  QualificationStreams: 'Qualification Streams',
  QualificationType: 'Qualification Type',
  Questions: 'Questions',
  Reason: 'Item Return Reason',
  Recommendation: 'Recommendation',
  Religion: 'Religion',
  Relationship: 'Relationship',
  reoffer: 'Re-Offer Letter',
  Reports: 'Report',
  ReqStatus: 'Item Requisition Status',
  ReuseJd: 'Reuse Job Description',
  ReuseReq: 'Reuse Requisition',
  RevenueType: 'Revenue Type',
  Role: 'Role',
  RoleLevel: 'Role Level',
  Root: 'Root',
  'role-permission': 'Role Permission',
  recruitment: 'Recruitment',
  RequisitionMapping: 'Candidate Requisition Mapping',
  RequirementList: 'Requisition List',
  reservedassets: 'Reserved Assets',
  Screens: 'Screens',
  ServiceCategory: 'Service Category',
  ServicePlan: 'Service Plan',
  SkillList: 'Skill',
  SkillCategory: 'Skill Category',
  SourceOfHire: 'Source Of Hire',
  SubInvType: 'Sub Inventory Type',
  SubInventory: 'Sub Inventory',
  OfferLetterContext: 'Offer Letter Context',
  'super-admin': 'Super Admin',
  TDS: 'TDS Section',
  TransactionType: 'Inventory Transaction Type',
  tag: 'Talent Acquisition',
  taginterview: 'Interview List',
  talentAcquisition: 'Talent Acquisition',
  tenantconfig: 'Preferences',
  UniqueIdentityDoc: 'Unique Identity Document',
  University: 'University',
  UOM: 'Unit Of Measure',
  UserMst: 'User',
  UserForm: 'New User',
  EditUser: 'Edit User',
  UserRoleAssign: 'User Role Assignment',
  ViewEmployee: 'View Employee',
  VendorMst: 'New Vendor',
  VisaName: 'Visa Name',
  VisaType: 'Visa Type',
  view: 'View Project',
  ViewCandidate: 'View Candidate',
  vendor: 'Vendor',
  WorkMode: 'Work Mode',
  workOrderList: 'Work Order List',
  createWorkOrder: 'New Work Order',
  Goods: 'Goods',
  Service: 'Service',
  OfferWithdrawReason: 'Offer Withdraw Reason',
  SelectedCandidates: 'Selected Candidates',
  ToDo: 'To Do',
  SubscriberSite: 'Subscriber Site',
  itemKits: 'Item Kit List',
  // Add more mappings as needed

  // AllPReqTag: 'Purchase Requisitions',
};
